import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function Careers() {
  const positions = [
    {
      title: 'Tile Installer',
      type: 'Full-Time',
      subType: 'Part-Time',
      location: 'Chicagoland area',
      description: 'We are seeking an experienced tile installer to join our team. You will be responsible for installing ceramic, porcelain, and natural stone tiles in residential and commercial settings.',
      requirements: [
        'Minimum 3 years of tile installation experience',
        'Knowledge of various tile materials and installation techniques',
        'Ability to read and follow specifications',
        'Strong attention to detail and quality craftsmanship',
        'Reliable transportation and own tools',
        'Excellent time management skills'
      ]
    },
    {
      title: "Entry Level / Carpenter's Helper",
      type: 'Full-Time',
      subType: 'Part-Time',
      location: 'Chicagoland area',
      description: 'Join our team as an Entry Level Professional and gain hands-on experience in residential remodeling. This is an excellent opportunity for someone looking to grow in the construction industry.',
      requirements: [
        'Basic knowledge of construction tools and materials',
        'Willingness to learn and take direction',
        'Physical ability to lift heavy materials',
        'Reliable and punctual',
        'Valid driver\'s license',
        'Team player with positive attitude'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6">
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-gray-500 hover:text-green-600 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Back to Home</span>
            </Link>
          </div>
          <div className="inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold text-lg mb-6 animate-pulse">
            NOW HIRING!
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Join Our Team
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            At Quality First Construction, we're always looking for talented, dedicated professionals to join our growing team. We specialize in high-quality residential remodeling and take pride in our craftsmanship and customer service.
          </p>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Why Work With Us?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-team-fill text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Great Team Environment
              </h3>
              <p className="text-gray-600">
                Work alongside experienced professionals who value collaboration and quality craftsmanship.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-line-chart-fill text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Growth Opportunities
              </h3>
              <p className="text-gray-600">
                We invest in our team's development and provide opportunities for career advancement.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-hand-coin-fill text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Competitive Compensation
              </h3>
              <p className="text-gray-600">
                We offer competitive wages that reflect your skills and experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Open Positions
          </h2>
          <div className="space-y-8">
            {positions.map((position, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-8 hover:shadow-lg transition-shadow">
                <div className="flex flex-wrap items-start justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {position.title}
                    </h3>
                    <div className="flex flex-wrap gap-3">
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                        <i className="ri-briefcase-fill mr-2"></i>
                        {position.type}
                      </span>
                      {position.subType && (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-orange-100 text-orange-800">
                          <i className="ri-time-fill mr-2"></i>
                          {position.subType}
                        </span>
                      )}
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                        <i className="ri-map-pin-fill mr-2"></i>
                        {position.location}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  {position.description}
                </p>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">Requirements:</h4>
                  <ul className="space-y-2">
                    {position.requirements.map((req, reqIndex) => (
                      <li key={reqIndex} className="flex items-start text-gray-700">
                        <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                        <span>{req}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application CTA */}
      <section className="py-16 px-6 bg-blue-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Ready to Apply?
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            We'd love to hear from you! Send your resume and a brief introduction to get started.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="mailto:Ken@QualityFirst-Construction.com"
              className="inline-flex items-center px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-fill text-xl mr-3"></i>
              Email Your Resume
            </a>
            <a
              href="tel:+17087077211"
              className="inline-flex items-center px-8 py-4 bg-blue-700 text-white rounded-lg font-semibold hover:bg-blue-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl mr-3"></i>
              Call Us: (708) 707-7211
            </a>
          </div>
          <p className="text-blue-100 mt-8">
            Email: <strong>Ken@QualityFirst-Construction.com</strong>
          </p>
        </div>
      </section>

      {/* Back to Home */}
      <section className="py-12 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center space-x-2 bg-white border border-gray-300 text-gray-700 font-semibold rounded-full px-6 py-3 hover:border-green-500 hover:text-green-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span>Back to Home</span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}